/** @format */

import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import CardWrap from "../../Common/CardWrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { inventoryService } from "../../../Services/AccountingServices/inventory.service";
import ResultModal from "../../Common/ResultModal";
import AddProductModal from "../../Common/AddProductModal";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as dateHelper from "../../../Helpers/DateHelper";
import cellEditFactory from "react-bootstrap-table2-editor";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import SpinnerLoading from "../../Common/SpinnerLoading";
import ActionModal from "../../Common/ActionModal";
import { AuthContext } from "../../../Contexts/AuthContext";
import InventoryDocuments from "./InventoryDocuments";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import XLSX from "xlsx";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";

const DocumentDetails = (props) => {
  const { isMobile } = useContext(GlobalContext);
  const { useAccounting } = useContext(AuthContext);
  const { t: translator } = useTranslation();
  const history = useHistory();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [update, setUpdate] = useState(new Date());
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [showDocuments, setShowDocuments] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [modalValidationMsg, setModalValidationMsg] = useState("");
  const [initValue, setInitValue] = useState({
    date: null,
    documentYear: null,
    storeId: 0,
    storeName: "",
    note: "",
    documentNumber: 0,
    tenantId: 0,
    priceListId: 0,
    inventoryDocumentGuid: "",
  });

  const [actionModal, setActionModal] = useState({
    title: "",
    text: "",
    show: false,
    confirmBtn: "",
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const addNewProduct = (productGuid, productName, price) => {
    setProducts([
      ...products,
      {
        inventoryDetailGuid: null,
        productGuid,
        productName,
        price,
        bookQuantity: 0,
        realQuantity: 0,
        isActive: true,
      },
    ]);
    setIsDisabled(false);
  };

  const onSubmit = (data) => {
    inventoryService
      .documentUpdate(
        initValue.inventoryDocumentGuid,
        initValue.storeId,
        initValue.date,
        initValue.documentYear,
        data.note,
        products
      )
      .then((res) => {
        if (res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-UpdateSuccess-Title",
            text: "InitialState-ResultModal-UpdateSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-UpdateError-Title",
            text: translator(res.data.message),
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleClose = () => {
    setModal({ ...modal, show: false });
    if (modal.success) {
      history.push("/inventory");
    }
  };

  const handleCancel = () => {
    history.push("/inventory");
  };

  useEffect(() => {
    if (!useAccounting) history.push("/error-page/401");

    inventoryService
      .getDocumentById(props.match.params.documentId)
      .then((res) => {
        if (res.data.data !== null) {
          setInitValue({
            ...initValue,
            date: res.data.data.documentDate,
            storeId: Number(res.data.data.storeId),
            storeName: res.data.data.storeName,
            note: res.data.data.note,
            documentNumber: res.data.data.documentNumber || 0,
            priceListId: res.data.data.priceListId,
            tenantId: res.data.data.tenantId,
            documentYear: res.data.data.documentYear,
            inventoryDocumentGuid: res.data.data.inventoryDocumentGuid,
          });
        }
        inventoryService
          .documentDetails(props.match.params.documentId)
          .then((res) => {
            setProducts(res.data.data);
            setIsLoading(false);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => err);
  }, [update]);

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }

  const handleLockDocument = () => {
    setActionModal({
      title: "InitialState-DocumentLock-Title",
      text: "InitialState-DocumentLock-Text",
      confirmBtn: "Confirm-Lock",
      confirmAction: confirmLock,
      show: true,
    });
  };

  const handleDeleteDocument = () => {
    setActionModal({
      title: "InitialState-DocumentDelete-Title",
      text: "InitialState-DocumentDelete-Text",
      confirmBtn: "Confirm-Delete",
      confirmAction: confirmDelete,
      show: true,
    });
  };

  const handleHideActionModal = () =>
    setActionModal({ ...actionModal, show: false });

  const confirmLock = () => {
    inventoryService
      .documentLock(props.match.params.documentId)
      .then((res) => {
        setActionModal({ ...modal, show: false });
        if (res && res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-LockSuccess-Title",
            text: "InitialState-ResultModal-LockSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-LockError-Title",
            text: "InitialState-ResultModal-LockError-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const confirmDelete = () => {
    inventoryService
      .documentDelete(props.match.params.documentId)
      .then((data) => {
        setActionModal({ ...actionModal, show: false });
        if (data.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-DeleteSuccess-Title",
            text: "InitialState-ResultModal-DeleteSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-DeleteError-Title",
            text: "InitialState-ResultModal-DeleteError-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) =>
        setModal({
          ...modal,
          title: "InitialState-ResultModal-DeleteError-Title",
          text: "InitialState-ResultModal-DeleteError-Text",
          show: true,
          btnClass: "btn btn-primary",
          success: false,
        })
      );
  };
  const exportExcelFunction = () => {
    var ws_name = `Inventura ${initValue.documentNumber}.xlsx`;
    // New work book
    var wb = XLSX.utils.book_new();
    // Constant Data
    var ws_data = [
      [translator("InvIssReport-Filters-Tenants"), "Prodajno mjesto"],
      ["", initValue.storeName],
      [translator("InvoiceCashBalancePDF-Date"), "Broj dokumenta"],
      [dateHelper.formatUtcToDate(initValue.date), initValue.documentNumber],
      [
        translator("Proizvod"),
        `Prodajna cijena (${activeCurrencyByDate(initValue.date)})`,
        "Uknjižena količina",
        "Stvarna količina",
        "Razlika",
      ],
    ];
    // Inconsistent data / Reports
    const ws_sufix = products.map((x) => {
      const array = [
        x.productName,
        x.price,
        x.bookQuantity,
        x.realQuantity,
        x.realQuantity - x.bookQuantity,
      ];
      return array;
    });
    // Merge data
    ws_data = [...ws_data, ...ws_sufix];
    // Export to xlsx
    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws["!cols"] = [{ width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }];
    XLSX.utils.book_append_sheet(wb, ws, "Inventura");
    XLSX.writeFile(wb, ws_name);
  };

  const options = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const { SearchBar } = Search;

  function currencyFormatter(cell) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: activeCurrencyByDate(initValue.date),
    }).format(Number(cell));
  }
  const columns = [
    {
      dataField: "productGuid",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
      searchable: false,
      hidden: initValue.documentNumber ? true : false,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          let newArr = [...products];
          let item = newArr.find((p) => p.productGuid === row.productGuid);
          item.isActive = false;

          setProducts(newArr);
          setIsDisabled(false);
        },
      },
    },
    {
      dataField: "productName",
      text: translator("InitialState-Product"),
      editable: false,
    },
    {
      dataField: "price",
      text: translator("InitialState-Price"),
      editable: false,
      formatter: currencyFormatter,
      searchable: false,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "bookQuantity",
      text: translator("InitialState-BookQuantity"),
      editable: false,
      searchable: false,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "realQuantity",
      text: `${translator("InitialState-RealQuantity")}*`,
      searchable: false,
      editable: initValue.documentNumber !== 0 ? false : true,
      validator: (newValue, row, column) => {
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("QuantityNumberMsg"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("QuantityNotNegative"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("QuantityMaxThousand"),
          };
        }

        setIsDisabled(false);
        return true;
      },
    },
  ];

  return (
    <>
      <CardWrap subtitle={translator("DocumentDetails")}>
        {!isLoading ? (
          <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-lg-4">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("InitialState-IndexData")}
                </legend>
                <div className="form-group">
                  <div>
                    <label className="boldedDocNumber">
                      <b>{translator("InitialState-DocumentNumber")}:</b>{" "}
                      {initValue.documentNumber !== 0
                        ? initValue.documentNumber
                        : translator("Document-NotLocked")}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-Date")}:</b>{" "}
                      {dateHelper.formatUtcToDate(initValue.date)}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-Year")}:</b>{" "}
                      {initValue.documentYear}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-Store")}:</b>{" "}
                      {initValue.storeName}
                    </label>
                  </div>
                  <div className="form-group">
                    <label>
                      <b>{translator("InitialState-Note")}:</b>
                    </label>
                    <textarea
                      name="note"
                      ref={register({ maxLength: 250 })}
                      className="form-control"
                      rows={4}
                      id="textArea"
                      defaultValue={initValue.note}
                      onChange={() => setIsDisabled(false)}
                      disabled={initValue.documentNumber !== 0 ? true : false}
                    ></textarea>
                    {errors.note && errors.note.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength250")}
                      </p>
                    )}
                  </div>
                </div>
              </fieldset>
              <div
                class="custom-card-footer row"
                style={{ borderTop: "1px solid #ccc", paddingTop: "22px" }}
              >
                <label class="control-label col-md-12">
                  * {translator("DangerArea")}
                </label>
                <div className="col-md-6">
                  <button
                    disabled={initValue.documentNumber ? true : false}
                    className="btn btn-outline-secondary btn-block"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLockDocument();
                    }}
                  >
                    {translator("Btn-Conclude")}
                  </button>
                </div>
                <div className="col-md-6">
                  <button
                    disabled={initValue.documentNumber ? false : true}
                    className="btn btn-outline-secondary btn-block"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowDocuments(true);
                    }}
                  >
                    {translator("Btn-Documents")}
                  </button>
                </div>

                <div className="col-md-12 mt-3">
                  <button
                    disabled={initValue.documentNumber ? true : false}
                    className="btn btn-danger btn-block"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleDeleteDocument();
                    }}
                  >
                    {translator("Btn-RemoveDoc")}
                  </button>
                </div>
                <div className="col-md-12 mt-3">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      exportExcelFunction();
                    }}
                    disabled={initValue.documentNumber ? false : true}
                    className="btn btn-outline-secondary btn-block"
                  >
                    {translator("Preuzmi dokument")}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("InitialState-Items")}
                </legend>
                <ToolkitProvider
                  keyField="productGuid"
                  data={products.filter((item) => item.isActive === true)}
                  columns={columns}
                  search
                >
                  {(props) => (
                    <>
                      {!initValue.documentNumber ? (
                        <div className="form-group">
                          {/* <button
                            className="btn btn-primary"
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setShowProductModal(true);
                            }}
                          >
                            {translator("InitialState-AddProduct")}
                          </button> */}
                          <span className="text-danger ml-2">
                            {translator(modalValidationMsg)}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="form-group">
                        <SearchBar
                          {...props.searchProps}
                          placeholder={translator("Search")}
                          className="col-md-12"
                        />
                      </div>

                      <hr />
                      <BootstrapTable
                        {...props.baseProps}
                        noDataIndication={translator("No-Data")}
                        pagination={paginationFactory(options)}
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                        })}
                      />
                      <p>
                        <span className="editableColumns">*</span>
                        {translator("EditableTableColumns")}
                      </p>
                    </>
                  )}
                </ToolkitProvider>
              </fieldset>
            </div>
            <div
              className="container-fluid mt-4"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={handleCancel}
              >
                {translator("POS-New_EditPOS-Close")}
              </button>
              &nbsp;
              <button
                className="btn btn-primary"
                disabled={isDisabled}
                type="submit"
              >
                {translator("POS-New_EditPOS-Save")}
              </button>
            </div>
          </form>
        ) : (
          <SpinnerLoading />
        )}
      </CardWrap>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
      <ActionModal
        show={actionModal.show}
        handleHide={handleHideActionModal}
        title={actionModal.title}
        text={actionModal.text}
        confirmBtn={actionModal.confirmBtn}
        confirmAction={actionModal.confirmAction}
      />
      <InventoryDocuments
        show={showDocuments}
        handleHide={() => setShowDocuments(false)}
        inventoryDocumentGuid={props.match.params.documentId}
      />
      {initValue.date !== null && (
        <AddProductModal
          show={showProductModal}
          tenantId={initValue.tenantId}
          priceListId={initValue.priceListId}
          addNewProduct={addNewProduct}
          handleHide={() => setShowProductModal(false)}
        />
      )}
    </>
  );
};

export default DocumentDetails;
